import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { UPDATE_CATEGORY } from "../category.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateCategoryInput } from "../../../__generated__/globalTypes";
import {
  UpdateCategoryMutation,
  UpdateCategoryMutationVariables,
} from "../../../__generated__/UpdateCategoryMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateCategory = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateCategoryInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateCategoryMutation,
    UpdateCategoryMutationVariables
  >(UPDATE_CATEGORY, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateCategory?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateCategory?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
